import React from 'react';
import { motion } from 'framer-motion';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BackgroundEffects from '@/components/BackgroundEffects';
import StoreButtons from '@/components/StoreButtons';
import PhoneMockup from '@/components/PhoneMockup';
import WaitlistPage from '@/components/WaitlistPage';
import ConsentBanner from '@/components/ConsentBanner';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

const stagger = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.1 },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] },
  },
};

const Landing = () => {
  return (
    <div className="relative min-h-screen bg-[#050505] overflow-hidden" data-testid="app-container">
      <BackgroundEffects />

      <div className="relative z-10 flex items-center justify-center min-h-screen px-6 sm:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row items-center lg:items-center justify-between w-full max-w-6xl gap-12 lg:gap-16 py-16 lg:py-0">

          <motion.div
            variants={stagger}
            initial="hidden"
            animate="show"
            className="flex flex-col items-center lg:items-start text-center lg:text-left flex-1 max-w-xl"
          >
            <motion.span
              variants={fadeUp}
              className="text-2xl font-black tracking-tighter text-white mb-10 sm:mb-14"
              style={{ fontFamily: "'Outfit', sans-serif" }}
              data-testid="prevy-logo"
            >
              Prevy
            </motion.span>

            <motion.h1
              variants={fadeUp}
              className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-medium tracking-tighter leading-[1.05]"
              style={{ fontFamily: "'Outfit', sans-serif" }}
              data-testid="hero-headline"
            >
              <span className="bg-clip-text text-transparent bg-gradient-to-b from-white to-white/60">
                Tu grupo.
              </span>
              <br />
              <span className="bg-clip-text text-transparent bg-gradient-to-b from-white to-white/60">
                Otros grupos.
              </span>
              <br />
              <span className="hero-previa">
                La <span className="hero-previa-logo">Previa</span> de tu vida
                <span className="hero-previa-gleam" aria-hidden="true">
                  La <span className="hero-previa-logo">Previa</span> de tu vida
                </span>
              </span>
            </motion.h1>

            <motion.p
              variants={fadeUp}
              className="text-base sm:text-lg text-zinc-400 font-light mt-6 max-w-md leading-relaxed"
              style={{ fontFamily: "'Manrope', sans-serif" }}
              data-testid="hero-subheadline"
            >
              Encontrad otros grupos con las mismas ganas de hacer previa que vosotros.
            </motion.p>

            {/* Store buttons (trap) */}
            <StoreButtons />
          </motion.div>

          <div className="flex-shrink-0 lg:flex-1 flex items-center justify-center">
            <PhoneMockup />
          </div>
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
      </Routes>
      <ConsentBanner />
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            color: '#fff',
            fontFamily: "'Manrope', sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
